module.exports = "https://health.dajiuxing.com.cn/img/assets/mine/3x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fmine%2F3x.png
// module id = osAO
// module chunks = 93